import { typographyTokens } from '../../theme/typographyTokens';
import { Box, Checkbox, FormControlLabel, Typography, Divider, Button, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { SEPPhase, SEPStatus, WORKFLOWTYPE, NewWorkflowType } from '../../../shared/types/SEP';

const filterTextSize = '13.2px';

interface StatusInterface {
  id: any;
  label: string;
  icon: string;
  iconColor: string;
}

const statusLists: StatusInterface[] = [
  {
    id: [
      SEPPhase.knockout,
      SEPPhase.design,
      SEPPhase.initiate,
      SEPPhase.implement,
    ],
    label: 'In Progress',
    icon: 'fa-regular fa-ellipsis',
    iconColor: '#7e8083',
  },
  {
    id: [SEPPhase.complete],
    label: 'Approved',
    icon: 'fa-solid fa-note-sticky',
    iconColor: '#2372B9',
  },

  {
    id: [SEPStatus.cancelled],
    label: 'Cancelled',
    icon: 'fa-solid fa-note-sticky',
    iconColor: '#2372B9',
  },
  {
    id: [SEPStatus.rejected],
    label: 'Rejected',
    icon: 'fa-solid fa-note-sticky',
    iconColor: '#2372B9',
  },
  {
    id: [SEPStatus.expired],
    label: 'Expired',
    icon: 'fa-solid fa-note-sticky',
    iconColor: '#2372B9',
  },
];
const phaseLists: any[] = [
 
  {
    id: [SEPPhase.knockout],
    label: 'Draft',
    icon: 'fa-solid fa-note-sticky',
    iconColor: '#2372B9',
  },
  {
    id: [SEPPhase.validation],
    label: 'Validation',
    icon: 'fa-solid fa-note-sticky',
    iconColor: '#2372B9',
  },
  {
    id: [SEPPhase.design],
    label: 'Design',
    icon: 'fa-solid fa-note-sticky',
    iconColor: '#2372B9',
  },
  {
    id: [SEPPhase.initiate],
    label: 'Initiate',
    icon: 'fa-solid fa-note-sticky',
    iconColor: '#2372B9',
  },
  {
    id: [SEPPhase.implement],
    label: 'Implement',
    icon: 'fa-solid fa-note-sticky',
    iconColor: '#2372B9',
  },
  {
    id: [SEPPhase.complete],
    label: 'Complete',
    icon: 'fa-solid fa-note-sticky',
    iconColor: '#2372B9',
  },
];



export const StyledCheckBox = ({
  indeterminate = false,
  checked,
  onChange,
  ariaLabel,
  label,
}: {
  indeterminate: boolean;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  ariaLabel: string;
  label: JSX.Element;
}) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          indeterminate={indeterminate}
          sx={{ p: 0.5 }}
          aria-label={ariaLabel}
          checked={checked}
          onChange={onChange}
        />
      }
      label={label}
      sx={{ mr: 0 }}
    />
  );
};

const MyToDosCheckbox = ({
  myToDosChecked,
  setMyToDosChecked,
  data,
}: {
  myToDosChecked: boolean;
  setMyToDosChecked: (value: boolean) => void;
  data: any;
}) => {
  const handleToDosCheckbox = () => {
    setMyToDosChecked(!myToDosChecked);
  };
  const theme = useTheme();

  return (
    <Box>
      <FormControlLabel
        control={
          <Checkbox
            indeterminate={false}
            sx={{ p: 0.5 }}
            aria-label="My To-Dos"
            checked={myToDosChecked}
            onChange={handleToDosCheckbox}
          />
        }
        label={
          <Box>
            <Typography
              fontSize={typographyTokens.fontSizes.caption}
              color={theme.palette.content.default}
              sx={{
                '&:hover': {
                  color: 'solidBlue.main',
                },
              }}
            >
              My To-Dos
            </Typography>
          </Box>
        }
        sx={{ mr: 0 }}
      />
    </Box>
  );
};

const SEPFilterBar = ({
  statusChecked,
  setStatusChecked,
  showTodo,
  setShowTodo,
  myToDosChecked,
  setMyToDosChecked,
  data,
  filterPage,
  workFlowChecked,
  setWorkFlowChecked,
  phaseChecked,
  setphaseChecked,
  finalData,
  keyTopicsChecked,
  setKeyTopicsChecked,
  keyTopicsOptions
}: {
  statusChecked: any;
  setStatusChecked: (value: any) => void;
  showTodo: boolean;
  setShowTodo: (value: boolean) => void;
  myToDosChecked: boolean;
  setMyToDosChecked: (value: boolean) => void;
  data: any;
  filterPage: string;
  workFlowChecked?: any
  setWorkFlowChecked?: any
  phaseChecked?: any;
  setphaseChecked?: (value: any) => void;
  finalData?: any
  keyTopicsChecked?: any
  setKeyTopicsChecked?: any
  keyTopicsOptions?: any
}) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  const workFlowList: any = finalData?.map((item: any) => ({
    id: [item],
    label: item,
    icon: 'fa-solid fa-note-sticky',
    iconColor: theme.palette.solidBlue.main,
  }));
  
  const buildKeyTopicsList = () => {
    const matched = keyTopicsOptions?.filter((item: any) => 
      item === 'Artificial Intelligence' || 
      item.toLowerCase().includes('artificial intelligence') ||
      item.toLowerCase().startsWith('calpine')
    ) || [];
    
    // Create individual checkboxes for each matched item
    const result = matched.map((item: any) => ({
      id: [item],  // Single item, not array
      label: item,
      icon: 'fa-solid fa-note-sticky',
      iconColor: theme.palette.solidBlue.main,
    }));
    
    return result;
  };
  
  const keyTopicsList: any = buildKeyTopicsList();
  const [drawOpen, setDrawOpen] = useState<boolean>(false);
 
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: SEPPhase[]
  ) => {
    if (id.length === 0) {
      if (event.target.checked)
        setStatusChecked(statusLists.map((list) => list.id).flat());
      else setStatusChecked([]);
      return;
    }

    if (event.target.checked) {
      setStatusChecked([
        ...statusChecked.filter((st: any) => id.indexOf(st) === -1),
        ...id,
      ]);
    } else {
      setStatusChecked([
        ...statusChecked.filter((st: any) => id.indexOf(st) === -1),
      ]);
    }
  };

  const workflowTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: SEPPhase[]
  ) => {
    if (id.length === 0) {
      if (event.target.checked)
        setWorkFlowChecked(workFlowList.map((list: any) => list.id).flat());
      else setWorkFlowChecked([]);
      return;
    }
    if (event.target.checked) {
      setWorkFlowChecked([
        ...workFlowChecked.filter((st: any) => id.indexOf(st) === -1),
        ...id,
      ]);
    } else {
      setWorkFlowChecked([
        ...workFlowChecked.filter((st: any) => id.indexOf(st) === -1),
      ]);
    }
  };

  const phaseChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  id: SEPPhase[]
) => {
  if (id.length === 0) {
    if (event.target.checked)
      setphaseChecked && setphaseChecked(phaseLists.map((list: any) => list.id).flat());
    else setphaseChecked && setphaseChecked([]);
    return;
  }
  if (event.target.checked) {
    setphaseChecked && setphaseChecked([
      ...phaseChecked.filter((st: any) => id.indexOf(st) === -1),
      ...id,
    ]);
  } else {
    setphaseChecked && setphaseChecked([
      ...phaseChecked.filter((st: any) => id.indexOf(st) === -1),
    ]);
  }
};

const keyTopicsChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  id: string[]
) => {
  if (id.length === 0) {
    if (event.target.checked)
      setKeyTopicsChecked && setKeyTopicsChecked(keyTopicsList.map((list: any) => list.id).flat());
    else setKeyTopicsChecked && setKeyTopicsChecked([]);
    return;
  }
  if (event.target.checked) {
    setKeyTopicsChecked && setKeyTopicsChecked([
      ...keyTopicsChecked.filter((st: any) => id.indexOf(st) === -1),
      ...id,
    ]);
  } else {
    setKeyTopicsChecked && setKeyTopicsChecked([
      ...keyTopicsChecked.filter((st: any) => id.indexOf(st) === -1),
    ]);
  }
};

  const isSelected = (ids: any) =>
    ids.every((id: any) => statusChecked.indexOf(id) !== -1);
  const isWorkFlowSelected = (ids: any) =>
    ids.every((id: any) => workFlowChecked.indexOf(id) !== -1);

  const isPhaseSelected = (ids: any) =>
    ids.every((id: any) => phaseChecked?.indexOf(id) !== -1);

  const isKeyTopicSelected = (ids: any) =>
    ids.every((id: any) => keyTopicsChecked?.indexOf(id) !== -1);

  return (
    <Box
      sx={{
        py: 1,
        backgroundColor: theme.palette.content.white,
        border: '1px solid',
        borderColor: theme.palette.supportingAdditional.tealContainerStroke,
        borderRadius: '6px',
        '& .MuiTypography-root': {
          color: theme.palette.content.default,
          fontSize: filterTextSize,
        },
        '& .MuiCheckbox-root': {
          color: theme.palette.prime.blue,
          '&.Mui-checked, &.MuiCheckbox-indeterminate': {
            color: theme.palette.prime.blue,
          },
        },
      }}
    >
    <Box
      display="flex"
      flexWrap="wrap"
      justifyContent={filterPage === 'allsep' ? "start" : 'start'}
      alignItems="center"
      gap="16px"
      px="16px"
      mb="16px"
      sx={{marginTop:"15px"}}
    >
      
      <Typography fontSize={typographyTokens.fontSizes.caption} color={theme.palette.content.default}>
        <b>View by Status:</b>
      </Typography>
      <StyledCheckBox
        indeterminate={
          statusChecked.length > 0 &&
          statusChecked.length <
            statusLists.map((list) => list.id).flat().length
        }
        checked={
          statusLists.length > 0 &&
          statusChecked.length ===
            statusLists.map((list) => list.id).flat().length
        }
        onChange={(event) => handleChange(event, [])}
        ariaLabel="Select All Statues"
        label={
          <Box>
            <Typography
              fontSize={typographyTokens.fontSizes.caption}
              color={theme.palette.content.default}
              sx={{
                '&:hover': {
                  color: 'solidBlue.main',
                },
              }}
            >
              All Statuses
            </Typography>
          </Box>
        }
      />
      {statusLists.map((list: StatusInterface, index: number) => {
        return (
          <StyledCheckBox
            key={list.label}
            indeterminate={false}
            ariaLabel={`Status Checkbox ${index}`}
            checked={isSelected(list.id)}
            onChange={(event) => handleChange(event, list.id)}
            label={
              <Box
                display="flex"
                alignItems="center" 
                gap="4px"
                sx={{
                  '& i': {
                    color: list.iconColor,
                  },
                  '&:hover': {
                    '& i': {
                      color: 'solidBlue.main',
                    },
                    '& p': {
                      color: 'solidBlue.main',
                    },
                  },
                }}
              >
                <Typography fontSize={typographyTokens.fontSizes.caption} color={theme.palette.content.default}>
                  {list.label}
                </Typography>
              </Box>
            }
          />
        );
      })}

      {/* {
        Object.values(SEPStatus).map((status: SEPStatus) => {
          return (
            <>
              {status !== SEPStatus.active && <StyledCheckBox
                key={status}
                indeterminate={false}
                ariaLabel={`Status Checkbox ${status}`}
                checked={false}
                onChange={() => handleStatusChange(status)}
                label={
                  <Box
                    display="flex"
                    alignItems="center"
                    gap="4px"
                    sx={{
                      '& i': {
                        color: '#7e8083',
                      },
                      '&:hover': {
                        '& i': {
                          color: 'solidBlue.main',
                        },
                        '& p': {
                          color: 'solidBlue.main',
                        },
                      },
                    }}
                  >
                    <Typography fontSize={typographyTokens.fontSizes.caption} color="gray.main" style={{textTransform:'capitalize'}}>
                      {status}
                    </Typography>
                  </Box>
                }
              />}
            </>
          );
        })
      } */}
      {showTodo && (
        <MyToDosCheckbox
          myToDosChecked={myToDosChecked}
          setMyToDosChecked={setMyToDosChecked}
          data={data}
        />
      )}
    </Box>
 
    {filterPage === 'allsep' && <Divider sx={{marginY:"10px"}} />}
    <Box
    display="flex"
    flexWrap="wrap"
    justifyContent= {filterPage === 'allsep' ? "start" : 'center'}
    alignItems="center"
    gap="16px"
    px="16px"
    mb="16px"
  >
    
    <Typography fontSize={typographyTokens.fontSizes.caption} color={theme.palette.content.default}>
        <b>View by WorkFlow Type:</b>
      </Typography>
      <StyledCheckBox
        indeterminate={
          workFlowChecked?.length > 0 &&
          workFlowChecked?.length <
          workFlowList?.map((list: any) => list.id).flat().length
        }
        checked={
          workFlowList?.length > 0 &&
          workFlowChecked?.length ===
          workFlowList.map((list: any) => list.id).flat().length
        }
        onChange={(event) => workflowTypeChange(event, [])}
        ariaLabel="Select All Statues"
        label={
          <Box>
            <Typography
              fontSize={typographyTokens.fontSizes.caption}
              color={theme.palette.content.default}
              sx={{
                '&:hover': {
                  color: 'solidBlue.main',
                },
              }}
            >
              All Workflow Types
            </Typography>
          </Box>
        }
      />
      {workFlowList?.map((list: StatusInterface, index: number) => {
        return (
          <StyledCheckBox
            key={list.label}
            indeterminate={false}
            ariaLabel={`Status Checkbox ${index}`}
            checked={isWorkFlowSelected(list.id)}
            onChange={(event) => workflowTypeChange(event, list.id)}
            label={
              <Box
                display="flex"
                alignItems="center" 
                gap="4px"
                sx={{
                  '& i': {
                    color: list.iconColor,
                  },
                  '&:hover': {
                    '& i': {
                      color: 'solidBlue.main',
                    },
                    '& p': {
                      color: 'solidBlue.main',
                    },
                  },
                }}
              >
                <Typography fontSize={typographyTokens.fontSizes.caption} color={theme.palette.content.default}>
                  {list.label}
                </Typography>
              </Box>
            }
          />
        );
      })}
    </Box>
    {filterPage === 'allsep' &&<> <Divider sx={{marginY:"10px"}} />
    <Box
    display="flex"
    flexWrap="wrap"
    justifyContent= {filterPage === 'allsep' ? "start" : 'center'}
    alignItems="center"
    gap="16px"
    px="16px"
    mb="16px"
  >
    
    <Typography fontSize={typographyTokens.fontSizes.caption} color={theme.palette.content.default}>
        <b>View by Phase:</b>
      </Typography>
      <StyledCheckBox
        indeterminate={
          phaseChecked?.length > 0 &&
          phaseChecked?.length <
          phaseLists?.map((list: any) => list.id).flat().length
        }
        checked={
          phaseChecked?.length > 0 &&
          phaseChecked?.length ===
          phaseLists.map((list: any) => list.id).flat().length
        }
        onChange={(event) => phaseChange(event, [])}
        ariaLabel="Select All Phases"
        label={
          <Box>
            <Typography
              fontSize={typographyTokens.fontSizes.caption}
              color={theme.palette.content.default}
              sx={{
                '&:hover': {
                  color: 'solidBlue.main',
                },
              }}
            >
              All Phases
            </Typography>
          </Box>
        }
      />
      {phaseLists?.map((list: StatusInterface, index: number) => {
        return (
          <StyledCheckBox
            key={list.label}
            indeterminate={false}
            ariaLabel={`Status Checkbox ${index}`}
            checked={isPhaseSelected(list.id)}
            onChange={(event) => phaseChange(event, list.id)}
            label={
              <Box
                display="flex"
                alignItems="center" 
                gap="4px"
                sx={{
                  '& i': {
                    color: list.iconColor,
                  },
                  '&:hover': {
                    '& i': {
                      color: 'solidBlue.main',
                    },
                    '& p': {
                      color: 'solidBlue.main',
                    },
                  },
                }}
              >
                <Typography fontSize={typographyTokens.fontSizes.caption} color={theme.palette.content.default}>
                  {list.label}
                </Typography>
              </Box>
            }
          />
        );
      })}
    </Box>
    </>
}
    {filterPage === 'allsep' && keyTopicsOptions && keyTopicsOptions.length > 0 && <>
    <Divider sx={{marginY:"10px"}} />
    <Box
    display="flex"
    flexWrap="wrap"
    justifyContent= {filterPage === 'allsep' ? "start" : 'center'}
    alignItems="center"
    gap="16px"
    px="16px"
    mb="16px"
  >
    
    <Typography fontSize={typographyTokens.fontSizes.caption} color={theme.palette.content.default}>
        <b>View by Key Topic:</b>
      </Typography>
      <StyledCheckBox
        indeterminate={
          keyTopicsChecked?.length > 0 &&
          keyTopicsChecked?.length <
          keyTopicsList?.map((list: any) => list.id).flat().length
        }
        checked={
          keyTopicsList?.length > 0 &&
          keyTopicsChecked?.length ===
          keyTopicsList.map((list: any) => list.id).flat().length
        }
        onChange={(event) => keyTopicsChange(event, [])}
        ariaLabel="Select All Key Topics"
        label={
          <Box>
            <Typography
              fontSize={typographyTokens.fontSizes.caption}
              color={theme.palette.content.default}
              sx={{
                '&:hover': {
                  color: 'solidBlue.main',
                },
              }}
            >
              All Key Topics
            </Typography>
          </Box>
        }
      />
      {keyTopicsList?.map((list: any, index: number) => {
        return (
          <StyledCheckBox
            key={list.label}
            indeterminate={false}
            ariaLabel={`Key Topic Checkbox ${index}`}
            checked={isKeyTopicSelected(list.id)}
            onChange={(event) => keyTopicsChange(event, list.id)}
            label={
              <Box
                display="flex"
                alignItems="center" 
                gap="4px"
                sx={{
                  '& i': {
                    color: list.iconColor,
                  },
                  '&:hover': {
                    '& i': {
                      color: 'solidBlue.main',
                    },
                    '& p': {
                      color: 'solidBlue.main',
                    },
                  },
                }}
              >
                <Typography fontSize={typographyTokens.fontSizes.caption} color={theme.palette.content.default}>
                  {list.label}
                </Typography>
              </Box>
            }
          />
        );
      })}
    </Box>
    </>
}
    {/* </Drawer> */}
    </Box>
  );
};

export default SEPFilterBar;
